export default [
    {
        header: 'Component(Sidebar):administration',
        action: 'visit',
        resource: 'administration',
    },
    {
        title: 'Component(Sidebar):administration-users',
        icon: 'UsersIcon',
        activeForRoutes: ['administration-user-add', 'administration-user-card'],
        route: 'administration-users',
        action: 'visit',
        resource: 'administration-users',
    },
    {
        title: 'Component(Sidebar):administration-suppliers',
        icon: 'BriefcaseIcon',
        activeForRoutes: [
            'administration-supplier-edit', 'administration-supplier-add', 'administration-production-units-add',
            'administration-production-units-edit'
        ],
        route: 'administration-suppliers',
        action: 'visit',
        resource: 'administration-suppliers',
    },
    {
        title: 'Component(Sidebar):administration-customers',
        icon: 'BriefcaseIcon',
        activeForRoutes: [],
        route: 'administration-customers',
        action: 'visit',
        resource: 'administration-customers',
    },
    {
        title: 'Component(Sidebar):administration-internal-organizations',
        icon: 'BriefcaseIcon',
        activeForRoutes: ['administration-internal-edit'],
        route: 'administration-internal-organizations',
        action: 'visit',
        resource: 'administration-internal-organizations',
    },
]
